// extracted by mini-css-extract-plugin
export default {"wrap":"index-module_wrap_pf6rn"};